<template>
  <div :class="[isReserved ? 'reserved' : '']">
    <el-row v-if="countryCode == 'QC'" :class="['text-left mb-15', isReserved ? 'pl-20 pt-40' : '']">
      <div class="text-left flex">
        <div>
          <h5 v-if="!isReserved" class="subtitle text-left">
            {{ title }}
          </h5>
          <h4 v-else style="font-weight: 900; color: #333333">
            {{ title }}
          </h4>
        </div>
        <div :class="[isReserved ? 'ml-5 mt-10' : 'mt-6 ml-30']">
          <el-popover
            v-if="productType == 'boutique'"
            placement="top-start"
            title=""
            width="290"
            trigger="hover"
          >
            <div v-html="botiqueDescription"></div>
            <QuestionMark slot="reference" />
          </el-popover>
          <QuestionMark v-else />
        </div>
      </div>
    </el-row>
    <el-row
      v-for="(productItem, i) in productsItems"
      :key="i"
      :class="[isReserved ? 'pl-20' : '']"
    >
      <div v-if="productItem">
        <ProductListCard
          :is-reserved="isReserved"
          :product="productItem.product"
          :ProductDefaultPrice="ProductDefaultPrice"
          :qty="productItem.quantity/productItem.item.uvc || 1"
          :unavailable="productItem.unavailable || false"
          @emit-remove="emitRemove"
          @emit-quantity-change="emitQuantityChange"
          :product-type="productType"
          />
          <!-- :qty="productItem.item.quantity.inStock ? 1 : 1" -->

      </div>
    </el-row>
    <el-row v-if="isReserved" style="height: 40px" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ProductListCard from "@/views/product/components/product-list-card.vue";
import QuestionMark from "@/components/question-mark.vue";

export default {
  components: {
    ProductListCard,
    QuestionMark,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    productsItems: {
      type: Array,
      default: () => [],
    },
    ProductDefaultPrice: {
      type: Array,
      default: () => [],
    },
    isReserved: {
      type: Boolean,
      default: false,
    },
    productType: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState("configuration", ["actionBar"]),

    countryCode() {
      return this.actionBar.country;
    },
    botiqueDescription() {
      return this.$i18n.t("products.boutiqueProductsQuebecView.description");
    },
  },
  methods: {
    emitRemove(puid) {
      this.$emit("emit-remove", puid);
    },
    /* eslint-disable object-curly-newline */
    emitQuantityChange({ puid, quantity }) {
           
      let cartProducts = [];
      try {
        cartProducts = JSON.parse(localStorage.getItem('cartProducts' + this.countryCode)) || [];
      } catch (e) {
        cartProducts = [];
      }
      if (!Array.isArray(cartProducts)) {
        cartProducts = [];
      }
      const product = cartProducts.find(product => product.puid === puid);
      if (product) {
        product.quantity = quantity;
      } else {
        // The line is on screen, so it exists in the server cart; the local
        // mirror is simply missing it (a wiped or never-seeded key). Adding it
        // back keeps the two in step — the old `console.warn` dropped the change
        // silently, so the displayed lines drifted away from the server total
        // that sales-orders/calculate returns.
        cartProducts.push({ puid, quantity });
      }
      localStorage.setItem('cartProducts' + this.countryCode, JSON.stringify(cartProducts));
      this.$emit("emit-quantity-change", { puid, quantity });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
.subtitle {
  font-weight: bold;
  color: #333333;
  height: 27px;
  font-family: $font-family-bold;
}
.question-mark {
  color: $color-primary;
  font-size: 14px;
  cursor: pointer;
}
.reserved {
  background-color: rgba(237, 240, 237, 0.33);
}
</style>
